export const TurnPrefrencesDrawer = (destinationLang) => {
  return [
    {
      FormKey: 'main-menu-settings-drawer-nobat-prefrences',
      Key: 'نوبت دهی',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey:
        'main-menu-settings-drawer-nobat-prefrences-show-fast-nobat',
      Key: 'نمایش نزدیک ترین نوبت',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey:
        'main-menu-settings-drawer-nobat-prefrences-show-today-nobat',
      Key: 'نمایش نوبت امروز',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey:
        'main-menu-settings-drawer-nobat-prefrences-show-time-nobat',
      Key: 'نمایش زمان نوبت',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey:
        'main-menu-settings-drawer-nobat-prefrences-show-holidays',
      Key: 'نمایش روز های تعطیل',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey:
        'main-menu-settings-drawer-nobat-prefrences-can-register',
      Key: 'امکان ثبت نام',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey:
        'main-menu-settings-drawer-nobat-agreement-rule-title',
      Key: 'قوانین و مقررات نوبت دهی',
      DistinitationLanguage: destinationLang,
    },
  ];
};
